// extracted by mini-css-extract-plugin
export default {"section":"hero_section__mHPgD"};